import React from 'react';
import { Container, Row, Col } from 'reactstrap';

import Ranking from './Ranking';
import Counter from './Counter';
import Header from './Header';
// import Footer from './Footer';
import './General.css';
import './MainPage.css';

const MainPage = () => {
  return (
    <Container fluid className="d-flex flex-column vh-100 vw-100 align-items-center">
      <Header />
      <Row className="h-100 align-items-center w-100 mt-3 mb-3">
        <Col lg={{ size: 8, offset: 0 }} xs="12">
          <Counter />
        </Col>
        <Col
          lg={{ size: 4, offset: 0 }}
          xs="12"
          className="align-self-lg-start order-first order-lg-last"
        >
          <Ranking />
        </Col>
      </Row>
      {/* <Row className="row-footer vw-100 justify-content-center align-items-center">
        <Footer />
      </Row> */}
    </Container>
  );
};

export default MainPage;
